"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogDownloadButton = exports.CatalogsListWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const catalogsListWrapCss = (0, util_theme_sxc_1.sx2CssThemeFn)(components_common_mixins_1.card, ({ theme }) => theme.catalogs.catalogsListWrap);
const CatalogDownloadButtonCss = (0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.catalogs.catalogsDownloadLink);
exports.CatalogsListWrap = styled_components_1.default.div(catalogsListWrapCss, {
    '.catalogs-link-image': {
        display: 'block',
        width: '100%',
    },
});
exports.CatalogDownloadButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon).attrs({
    variant: 'iconBtn',
    icon: { name: 'download' },
    testId: 'catalogDownload',
})(CatalogDownloadButtonCss);
//# sourceMappingURL=fdr-catalogs-card.styles.js.map